import { atom } from "jotai";
import { Conversation } from "@/core/entities/conversation";
import { AppConfig } from "@/infrastructure/services/config";

const _appConfig = AppConfig.getInstance();
const PAGINATION_PAGE_LIMIT = _appConfig.PAGINATION_PAGE_LIMIT;
const INITIAL_PAGE = 1;

interface ConversationState {
  searchQuery: string | null;
  conversations: Conversation[];
  total: number;
  page: number;
  limit: number;
  currentConversation: Conversation | null;
  isLoading: boolean;
  newMessageCount: number;
}

const initialState: ConversationState = {
  searchQuery: null,
  conversations: [],
  total: 0,
  page: INITIAL_PAGE,
  limit: PAGINATION_PAGE_LIMIT,
  currentConversation: null,
  isLoading: false,
  newMessageCount: 0,
};

export const conversationAtom = atom<ConversationState>(initialState);
export const getNewMessageCountAtom = atom(get => get(conversationAtom).newMessageCount);

export const INITIAL_PAGE_CONST = INITIAL_PAGE;

